import { isValidCurrencyAmount, isNumeric } from './validation';

export const forceMaxLength = (e: any) => {
  const { value, maxLength } = e.currentTarget;

  if (value.length > maxLength) {
    e.currentTarget.value = value.slice(0, maxLength);
  }
};

/**
 * @description
 * Remove cents entirely if .00
 * Remove leading zeros
 * Add 0 to cents if only the first cent amount after is provided. Example convert 10.5 to 10.50
 */
export const sanitizeOtherAmount = (amount: string) => {
  // It's not even valid, don't try to clean.
  if (!isValidCurrencyAmount(amount)) {
    return amount;
  }

  const cleaned = parseFloat(amount);
  return cleaned.toFixed(2).replace('.00', '');
};

/**
 * @description
 * force only numbers
 * Don't allow user input
 */
export const forceOnlyNumbers = (e: any) =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();

/**
 *  @param month  string
 * @returns Pads the month with a leading zero if one is not present.
 */
export const formatCreditCardMonth = (month: string): string => {
  const cleanMonth = month.trim();
  if (!isNumeric(cleanMonth) || cleanMonth === '0') return month;

  return cleanMonth.padStart(2, '0');
};
